import { Play } from 'lucide-react'
import type { NodeProps } from '@xyflow/react'
import { NodeShell } from './nodeTypes'
import type { FlowNode } from './nodeTypes'

export function StartNode({ data, selected }: NodeProps<FlowNode>) {
  return (
    <NodeShell
      icon={Play}
      label={data.label}
      accentColor="#4ade80"
      selected={selected}
      showTargetHandle={false}
    />
  )
}
